const Arrow = ({ fill = '#000000' }) => (
  <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.68359 0.291992C6.85449 0.291992 7.02539 0.360352 7.1416 0.490234L12.4326 5.91113C12.5488 6.02734 12.6172 6.17773 12.6172 6.34863C12.6172 6.7041 12.3506 6.97754 11.9951 6.97754C11.8242 6.97754 11.667 6.90918 11.5508 6.7998L6.68359 1.82324L1.80957 6.7998C1.7002 6.90918 1.54297 6.97754 1.36523 6.97754C1.00977 6.97754 0.743164 6.7041 0.743164 6.34863C0.743164 6.17773 0.811523 6.02734 0.927734 5.9043L6.21875 0.490234C6.34863 0.360352 6.50586 0.291992 6.68359 0.291992Z" fill={fill} />
  </svg>
);

export default Arrow;
